var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public"},[(!_vm.isJgj)?_c('div',{staticClass:"topFixed"},[_c('div',{staticClass:"topContent"},[_c('home-top'),_c('home-header')],1)]):_vm._e(),_c('router-view',{class:{ view: !_vm.isJgj }}),(!_vm.isJgj)?_c('home-footer'):_vm._e(),(!_vm.isJgj)?_c('fixed-btn'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }